export const skippablePromise = () => {
    let promiseReslove = null;
    const runPromise = async (promises, callBack) => {
        const skipPromise = new Promise((resolve) => {
            promiseReslove = resolve
        })
        await Promise.race([
            Promise.all(promises),
            skipPromise.then()
        ])
        callBack()
        promiseReslove = null
    }
    const skipPromise = () => {
        if (promiseReslove) promiseReslove()
    }

    return { runPromise, skipPromise }
}